const Hours = ({ estTime }) => `${estTime}h`;

export default Hours;
